var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"0521a2854e602855f1507bf5c523adee053bfe29"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["bridge128@bridge128-96"]={id:"0521a2854e602855f1507bf5c523adee053bfe29"};
      